import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Card } from '@material-ui/core';
import Text from 'Components/ComponentLibrary/Atoms/Text';

export const COLORS = [
  'primary',
  'primaryGray',
];

const useStyles = buildUseStyles('AccountCard', (theme) => ({
  root: {
    width: '100%',
    boxShadow: 'unset',
    border: `1px solid ${theme.palette.facet.lightGray2}`,
    borderRadius: theme.radius.md,
    padding: theme.spacing(1, 2),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  label: {
    marginBottom: theme.spacing(1),
  },
  imageContainer: {
    display: 'flex',
    placeContent: 'center',
    maxHeight: 40,
    maxWidth: 40,
    padding: theme.spacing(1),
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: '50%',
    borderColor: theme.palette.facet.lightGray2,
  },
  image: {
    width: '100%',
  },
  accountDetails: {
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  accountNumber: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  name: {
    fontSize: theme.typography.fontSize1Rem,
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const AccountCard = ({
  className,
  iconSrc,
  accountName,
  maskedAccountNumber,
  balance,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Card className={classNames(className, classes.root)}>
      {iconSrc && <Box className={classes.imageContainer}><img className={classes.image} src={iconSrc} alt={'facet-logo'} /></Box>}
      <Box className={classes.accountDetails}>
        <Text
          className={classes.name}
          align={'left'}
          text={accountName}
          color={'textPrimary'}
        />
        <Text
          className={classes.accountNumber}
          align={'left'}
          color={'textSecondary'}
          text={maskedAccountNumber}
        />
        { balance && (
        <Text
          className={classes.accountNumber}
          align={'left'}
          color={'textSecondary'}
          text={`Current balance: ${balance}`}
        />
        )}
      </Box>
    </Card>
  );
};

AccountCard.defaultProps = {
  className: '',
  iconSrc: '',
};

AccountCard.propTypes = {
  className: PropTypes.string,
  iconSrc: PropTypes.string,
  accountName: PropTypes.string.isRequired,
  maskedAccountNumber: PropTypes.string.isRequired,
  balance: PropTypes.string,
};

export default AccountCard;
